import { render, staticRenderFns } from "./ProfileViewer.vue?vue&type=template&id=1f5d28ab&scoped=true&"
import script from "./ProfileViewer.vue?vue&type=script&lang=js&"
export * from "./ProfileViewer.vue?vue&type=script&lang=js&"
import style0 from "./ProfileViewer.vue?vue&type=style&index=0&id=1f5d28ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d28ab",
  null
  
)

export default component.exports